// Feature 009: Deal Operating System
// Welcome banner for first-time orientation
// Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2)
import React, { useState, useEffect } from 'react';

const WelcomeBanner = () => {
  const [dismissed, setDismissed] = useState(true); // Default to dismissed to avoid flash

  useEffect(() => {
    // Check localStorage after mount to prevent SSR issues
    const isDismissed = localStorage.getItem('welcomeBannerDismissed') === 'true';
    setDismissed(isDismissed);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('welcomeBannerDismissed', 'true');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="bg-[#0a0a0a] border border-[rgba(161,198,162,0.3)] p-6 mb-6 mx-8 mt-4">
      <div className="flex justify-between items-start">
        <div>
          <h2
            className="text-xl font-semibold text-[#fffbf7] mb-2"
            style={{ fontFamily: "'GT Pressura Mono', monospace" }}
          >
            Welcome to USOKIE Deal Desk
          </h2>
          <p className="text-sm text-[rgba(255,251,247,0.7)] mb-4 max-w-2xl">
            Track licensing deals from intake through production. Drag deals between
            stages, upload documents for AI extraction, and manage your pipeline.
          </p>
          <div className="flex gap-4">
            <span
              className="text-[10px] text-[rgba(255,251,247,0.5)] tracking-[0.15em] uppercase"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              Press <kbd className="px-1 py-0.5 bg-black border border-[rgba(255,251,247,0.2)] text-[#fffbf7]">N</kbd> to create new opportunity
            </span>
            <span
              className="text-[10px] text-[rgba(255,251,247,0.5)] tracking-[0.15em] uppercase"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              Press <kbd className="px-1 py-0.5 bg-black border border-[rgba(255,251,247,0.2)] text-[#fffbf7]">A</kbd> for AI assistant
            </span>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-[rgba(255,251,247,0.5)] hover:text-[#fffbf7] text-xl transition-colors p-1"
          aria-label="Dismiss welcome banner"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
